const AUTH_STORAGE_KEYS = {
  token: "accessToken",
  tokenExpiration: "accessTokenExpiration",
  user: "authUser",
};

export function getAccessToken() {
  return localStorage.getItem(AUTH_STORAGE_KEYS.token);
}

export function setAuthSession({ accessToken, accessTokenExpiration, user }) {
  if (typeof accessToken !== "undefined") {
    if (accessToken) {
      localStorage.setItem(AUTH_STORAGE_KEYS.token, accessToken);
    } else {
      localStorage.removeItem(AUTH_STORAGE_KEYS.token);
    }
  }

  if (typeof accessTokenExpiration !== "undefined") {
    if (accessTokenExpiration) {
      localStorage.setItem(AUTH_STORAGE_KEYS.tokenExpiration, String(accessTokenExpiration));
    } else {
      localStorage.removeItem(AUTH_STORAGE_KEYS.tokenExpiration);
    }
  }

  if (typeof user !== "undefined") {
    if (user) {
      localStorage.setItem(AUTH_STORAGE_KEYS.user, JSON.stringify(user));
    } else {
      localStorage.removeItem(AUTH_STORAGE_KEYS.user);
    }
  }
}

export function clearAuthSession() {
  localStorage.removeItem(AUTH_STORAGE_KEYS.token);
  localStorage.removeItem(AUTH_STORAGE_KEYS.tokenExpiration);
  localStorage.removeItem(AUTH_STORAGE_KEYS.user);
}

export function hasSessionToken() {
  return Boolean(getAccessToken());
}
